import { Card, Button } from "antd";
import { useNavigate } from "react-router-dom";

export default function BuyCreditsCard() {

  const navigate = useNavigate()
  return (
    <Card
      className="rounded-3xl overflow-hidden"
      styles={{
        body: {
          background:
            "linear-gradient(135deg,#7C3AED,#9333EA)",
          color: "white",
        },
      }}
    >
      <h2 className="text-xl font-bold">
        Buy More Credits
      </h2>

      <p className="mt-2 opacity-90">
        Get more credits to optimize more
        images and save more.
      </p>

      <Button
      onClick={()=>navigate('/buy')}
        className="mt-4"
        size="large"
      >
        Buy Credits Now
      </Button>
    </Card>
  );
}